import React from "react";
import { Table } from "reactstrap";
import CircularProgress from "../../../CircularProgress/CircularProgress";
import { Badge } from "reactstrap";
import translate from "../../../../utils/Translator";

import style from "./Grid.module.scss";

const Grid = ({ data, loading, Link }) => {
  return (
    <div className={style.grid}>
      <Table id="funds-report-table" className={style.table} striped>
        <thead>
          <tr>
            <th>{translate("Account")} Name Fund</th>
            <th>{translate("Account")} Number Fund</th>
            <th>Value Quantity Funds</th>
            <th>Value Quantity To Compare Funds</th>
            <th>{translate("Account")} Name CSBA</th>
            <th>{translate("Account")} Number CSBA</th>
            <th>Value Quantity CSBA</th>
            <th>Difference</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <EmptyTable loading={true} />
          ) : !data || data.length == 0 ? (
            <EmptyTable />
          ) : (
            data.map((d, i) => (
              <tr key={`c-${(d.Funds && d.Funds.AccountId) || (d.CSBA && d.CSBA.AccountId)}-${i}`}>
                <td>{d.Funds && d.Funds.AccountName}</td>
                <td>{d.Funds && d.Funds.AccountNumber}</td>
                <td>{d.Funds && d.Funds.valueQuantity}</td>
                <td>{d.Funds && d.Funds.valueQuantityRealToCompare}</td>
                <td>{d.CSBA && d.CSBA.AccountName}</td>
                <td>{d.CSBA && d.CSBA.AccountNumber}</td>
                <td>{d.CSBA && d.CSBA.valueQuantity}</td>
                <td>{renderShareDifference(d)}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
};

const renderShareDifference = (d) => {
  if (!d.Merge) return null;
  const { diffQuantityFundsCSBA, haveDiference, decimalPlaceAllowedError } = d.Merge;
  const color = haveDiference ? "danger" : "success";
  const diff = haveDiference ? diffQuantityFundsCSBA : (0).toFixed(decimalPlaceAllowedError);

  return (
    <Badge color={color} className={style.badge}>
      {diff}
    </Badge>
  );
};

const EmptyTable = ({ loading }) => (
  <tr className={style.empty}>
    <td colSpan="7" style={{ textAlign: "center", padding: "60px" }}>
      {loading ? <CircularProgress style={{ marginTop: "10%" }} /> : <h4>No values</h4>}
    </td>
  </tr>
);

export default Grid;
